import { AdminCompanyBankAccountDto, AdminCompanyDto, AdminCompanySearchDto, AdminCompanyDetailDtoPaymentProcessingStatusEnum, AdminCompanySearchDtoAdminViewEnum  } from "@inosio/payments-sdk";
import { CircularProgress, FormControl, Grid, InputLabel, Link, MenuItem, Paper, Select, SelectChangeEvent, Stack, Box, Typography, Button } from "@mui/material";
import { Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, Tooltip } from "@mui/material";
import React, { KeyboardEvent } from "react";
import { useDispatch, useSelector } from "react-redux";
import LogoutIcon from "@mui/icons-material/Logout";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { clearCredentials } from "../../shared/sagas/auth/authSlice";
import { getCompanies, selectCompanyHistory, selectAdminState, selectCompanyHistoryCurrentPage, getCompanyDetail, clearCompanyDetail, getExportBankFiles, getUpdateCompanyProductConfigs, submitOnboardMerchant, clearAdminCompanyFlags } from "../sagas/adminPortal.slice";
import { HashLoader } from "react-spinners";
import { css } from "@emotion/react";
import CopyToClipboard from "react-copy-to-clipboard";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { format } from "date-fns";
import CompanyDetailsIcon from '../../icons/paymentHistoryDetailsIcon.png';
import { capitalizeFirstLetter } from "../../pmui/PmUI";
import { makeStyles } from "@mui/styles";
import BackIcon from "../../icons/backIcon.svg";
import PatternFormat from 'react-number-format';
import PortalIcon from "../../icons/ResidentPortal.svg";
import ExportIcon from "../../icons/exportIcon2.svg";

enum SearchFieldTypes {
  Name = "Name",
  Uuid = "Uuid",
}

enum PageStates {
  Companies = "Companies",
  CompanyDetail = "CompanyDetail",
  BankDetail = "BankDetail",
}

const useStyles = makeStyles((theme) => ({
  labelText: {
    fontFamily: 'Work Sans !important',
    fontStyle: 'normal !important',
    fontWeight: '400 !important',
    fontSize: '18px !important',
    lineHeight: '21px !important',
    color: '#14142B',
  },
  sectionLabel: {
    fontFamily: 'Open Sans !important',
    fontStyle: 'normal !important',
    fontWeight: '500 !important',
    fontSize: '20px !important',
    lineHeight: '25px !important',
    color: '#000000',
  },
}));

export default function AdminCompanies() {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [searchField, setSearchField] = React.useState<string>(SearchFieldTypes.Name);
  const [searchValue, setSearchValue] = React.useState("");
  const [rangeSize, setRangeSize] = React.useState(20);
  const [currentPage, setCurrentPage] = React.useState(0);
  const [startIndex, setStartIndex] = React.useState(0);
  const [openToolTip, setOpenToolTip] = React.useState(null);
  const { isCompaniesFetching, isCompanyDetailFetching, CompanyDetail, companyDetailError, isExportingBankFiles, isSubmittingOnboardMerchant, isSubmittingOnboardMerchantSuccess, isUpdatingCompanyProductConfigs, isUpdatingCompanyProductConfigsSuccess } = useSelector(selectAdminState);
  const companyData = useSelector(selectCompanyHistory);
  const companyDataBook = useSelector(selectCompanyHistoryCurrentPage);
  const [adminView, setAdminView] = React.useState<AdminCompanySearchDtoAdminViewEnum|string>('all');

  const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, newPageNumber: number) => {
    setCurrentPage(newPageNumber);
    setStartIndex(+newPageNumber * +rangeSize);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setCurrentPage(0);
    setStartIndex(0);
    setRangeSize(parseInt(event.target.value));
  };

  const onToggleClick = (index:any) => {
    setOpenToolTip(openToolTip === index ? null : index)
  }

  React.useEffect(() => {
    !!searchField && dispatch({
      type: getCompanies.type,
      payload: {
        Name: searchField === SearchFieldTypes.Name ? searchValue : undefined,
        Uuid: searchField === SearchFieldTypes.Uuid ? searchValue : undefined,
        StartIndex: startIndex,
        RangeSize: rangeSize,
        AdminView: adminView === 'all' ? '' : adminView,
      } as AdminCompanySearchDto,
    });
  }, [dispatch, rangeSize, startIndex, adminView]);

  const override = css`
    display: block;
    margin: 15% auto auto;
  `;

  const [pageState, setPageState] = React.useState<PageStates>(PageStates.Companies);
  const [selectedCompany, setSelectedCompany] = React.useState<AdminCompanyDto>();
  const handleViewCompanyDetail = (company: AdminCompanyDto) => {
    setPageState(PageStates.CompanyDetail);
    setSelectedCompany(company);
    dispatch({
      type: getCompanyDetail.type,
      payload: {
        CompanyUuid: company.Uuid,
      },
    });
  }

  const achMerchant = CompanyDetail.MerchantProcessing?.find((m) => m.PaymentType === 'ACH');
  const cardMerchant = CompanyDetail.MerchantProcessing?.find((m) => m.PaymentType === 'CC' || m.PaymentType === 'DB');

  const [selectedBank, setSelectedBank] = React.useState<AdminCompanyBankAccountDto>();
  const achCredit = selectedBank?.Peers?.find((p) => p.PaymentType === 'ACH' && p.Type === 'CREDIT');
  const achDebit = selectedBank?.Peers?.find((p) => p.PaymentType === 'ACH' && p.Type === 'DEBIT');
  const cardCredit = selectedBank?.Peers?.find((p) => p.PaymentType === 'CC' && p.Type === 'CREDIT');
  const cardDebit = selectedBank?.Peers?.find((p) => p.PaymentType === 'CC' && p.Type === 'DEBIT');

  const handleViewBankAccount = (ba: AdminCompanyBankAccountDto) => {
    setSelectedBank(ba);
    setPageState(PageStates.BankDetail);
  }

  const handleExportBankAccountFiles = (companyUuid: string, ba: AdminCompanyBankAccountDto) => {
    setSelectedBank(ba);
    dispatch({
      type: getExportBankFiles.type,
      payload: {
        CompanyUuid: companyUuid,
        BankUuid: ba.Uuid,
      },
    });
  }

  const [paymentsMFlag, setPaymentsMFlag] = React.useState('no');
  const [applicationsMFlag, setApplicationsMFlag] = React.useState('no');
  const [maintenanceMFlag, setMaintenanceMFlag] = React.useState('no');

  React.useEffect(() => {
    setPaymentsMFlag(CompanyDetail.ProductConfigs?.PaymentsMasterFlag ? 'yes' : 'no');
    setApplicationsMFlag(CompanyDetail.ProductConfigs?.ApplicationsMasterFlag ? 'yes' : 'no');
    setMaintenanceMFlag(CompanyDetail.ProductConfigs?.MaintenanceMasterFlag ? 'yes' : 'no');
  }, [CompanyDetail])

  const onboardMerchant = () => {
    dispatch({
      type: submitOnboardMerchant.type,
      payload: {
        CompanyUuid: CompanyDetail.Uuid,
      },
    });
  }

  const [isUpdatingPaymentOnboarding, setIsUpdatingPaymentOnboarding] = React.useState(false);
  const [isUpdatingApplicationOnboarding, setIsUpdatingApplicationOnboarding] = React.useState(false);
  const [isUpdatingMaintenanceOnboarding, setIsUpdatingMaintenanceOnboarding] = React.useState(false);
  React.useEffect(() => {
    if (isSubmittingOnboardMerchantSuccess || isUpdatingCompanyProductConfigsSuccess) {
      dispatch(clearAdminCompanyFlags());
      dispatch({
        type: getCompanyDetail.type,
        payload: {
          CompanyUuid: CompanyDetail.Uuid,
        },
      });
      setIsUpdatingPaymentOnboarding(false);
      setIsUpdatingApplicationOnboarding(false);
      setIsUpdatingMaintenanceOnboarding(false);
    }
  }, [isSubmittingOnboardMerchantSuccess, isUpdatingCompanyProductConfigsSuccess])

  return (
    <Stack sx={{ position: "relative" }}>
      {/* show this when ui is fetching data */}
      {(isCompaniesFetching || isCompanyDetailFetching) && (
        <Box sx={{ height: "100%", width: "100%", position: "absolute", top: "10%", backgroundColor: "#fff", opacity: "0.5", zIndex: 1000 }}>
          <HashLoader color={"#BABABA"} loading={isCompaniesFetching || isCompanyDetailFetching} size={150} css={override} />
        </Box>
      )}

      <Grid container>
        {pageState === PageStates.Companies ? (
          <>
            <Grid item>
              <FormControl sx={{ m: 1, ml: 4, width: 200 }} size="small">
                <InputLabel>Admin View</InputLabel>
                <Select value={adminView} label="Admin View" onChange={(e: SelectChangeEvent) => setAdminView(e.target.value)}>
                  <MenuItem value='all'>
                    All
                  </MenuItem>
                  {(Object.keys(AdminCompanySearchDtoAdminViewEnum) as (keyof typeof AdminCompanySearchDtoAdminViewEnum)[]).map((view, index) => {
                    return (
                      <MenuItem value={AdminCompanySearchDtoAdminViewEnum[view]} key={index}>
                        {AdminCompanySearchDtoAdminViewEnum[view]}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Grid>
            <Grid item>
              <FormControl sx={{ m: 1, ml: 4, width: 200 }} size="small">
                <InputLabel>Search By</InputLabel>
                <Select value={searchField} label="Search By" onChange={(e: SelectChangeEvent) => setSearchField(e.target.value)}>
                  {(Object.keys(SearchFieldTypes) as (keyof typeof SearchFieldTypes)[]).map((searchField, index) => {
                    return (
                      <MenuItem value={SearchFieldTypes[searchField]} key={index}>
                        {SearchFieldTypes[searchField]}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Grid>
            <Grid item>
              <FormControl sx={{ m: 1, ml: 3, width: 300, ".MuiInputBase-input": { paddingBottom: "8px" }, ".MuiInputLabel-root": { marginTop: "-6px" }, ".MuiInputBase-root": { marginTop: "8px" } }}>
                <TextField
                  onKeyPress={(e: KeyboardEvent<HTMLInputElement>) => {
                    if (e.key === "Enter") {
                      dispatch({
                        type: getCompanies.type,
                        payload: {
                          Name: searchField === SearchFieldTypes.Name ? searchValue : undefined,
                          Uuid: searchField === SearchFieldTypes.Uuid ? searchValue : undefined,
                          StartIndex: startIndex,
                          RangeSize: rangeSize,
                          AdminView: adminView === 'all' ? '' : adminView,
                        } as AdminCompanySearchDto,
                      });
                    }
                  }}
                  label="value"
                  variant="standard"
                  size="small"
                  value={searchValue}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSearchValue(e.target.value)}
                />
              </FormControl>
            </Grid>
            <Grid>
              <Tooltip title="reset selection">
                <Link
                  href="#"
                  color="inherit"
                  onClick={() => {
                    setSearchField(SearchFieldTypes.Name);
                    setSearchValue("");
                    setAdminView('all');
                    dispatch({
                      type: getCompanies.type,
                      payload: {
                        StartIndex: startIndex,
                        RangeSize: rangeSize,
                        AdminView: adminView === 'all' ? '' : adminView,
                      } as AdminCompanySearchDto,
                    });
                  }}
                  sx={{ display: "block", marginTop: "16px" }}
                >
                  <RestartAltIcon />
                </Link>
              </Tooltip>
            </Grid>
          </>
        ) : pageState === PageStates.CompanyDetail ? (
          <Box sx={{ display: "flex", alignItems: "center", ml: 4 }}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <img
                style={{
                  cursor: "pointer",
                  width: "20px",
                  height: "20px",
                }}
                src={BackIcon}
                alt="backicon"
                onClick={() => {
                  setPageState(PageStates.Companies);
                  dispatch(clearCompanyDetail());
                  setSelectedCompany(undefined);
                }}
              />
              <Typography sx={{ ml: 1 }} className={classes.labelText}>
                {selectedCompany?.Name ?? ''}
              </Typography>
            </Box>
            {CompanyDetail.AdminPm && (
              <Box sx={{ mx: 1, borderLeft: '1px solid #F1F0F5' }}>
                <Typography sx={{ ml: 1 }} className={classes.labelText}>
                  {`Admin PM: ${CompanyDetail.AdminPm.FirstName} ${CompanyDetail.AdminPm.LastName}`}
                </Typography>
              </Box>
            )}
            {CompanyDetail.Email && (
              <Box sx={{ mx: 1, borderLeft: '1px solid #F1F0F5' }}>
                <Typography sx={{ ml: 1 }} className={classes.labelText}>
                  {`Email: ${CompanyDetail.Email}`}
                </Typography>
              </Box>
            )}
            {CompanyDetail.PhoneNumber && (
              <Box sx={{ mx: 1, borderLeft: '1px solid #F1F0F5' }}>
                <Typography sx={{ ml: 1 }} className={classes.labelText}>
                  Phone:
                  <PatternFormat
                    value={CompanyDetail.PhoneNumber ?? ''}
                    displayType="text"
                    type="tel"
                    format={CompanyDetail.PhoneNumber?.length > 10 ? "+# (###) ###-####" : "+1 (###) ###-####"}
                  />
                </Typography>
              </Box>
            )}
          </Box>
        ) : pageState === PageStates.BankDetail ? (
          <Box sx={{ display: "flex", alignItems: "center", ml: 4 }}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <img
                style={{
                  cursor: "pointer",
                  width: "20px",
                  height: "20px",
                }}
                src={BackIcon}
                alt="backicon"
                onClick={() => {
                  setPageState(PageStates.CompanyDetail);
                  setSelectedBank(undefined);
                }}
              />
              <Typography sx={{ ml: 1 }} className={classes.labelText}>
                {selectedBank?.BankName ?? ''}
              </Typography>
            </Box>
            {selectedBank && (
              <>
                <Box sx={{ mx: 1, borderLeft: '1px solid #F1F0F5' }}>
                  <Typography sx={{ ml: 1 }} className={classes.labelText}>
                    {`Account Number: ${selectedBank?.AccountNumber ?? ''}`}
                  </Typography>
                </Box>
                <Box sx={{ mx: 1, borderLeft: '1px solid #F1F0F5' }}>
                  <Typography sx={{ ml: 1 }} className={classes.labelText}>
                    {`Routing Number: ${selectedBank?.RoutingNumber ?? ''}`}
                  </Typography>
                </Box>
              </>
            )}
          </Box>
        ) : (
          <></>
        )}
        <Grid item sx={{ marginLeft: "auto", paddingRight: "2%" }}>
          <Box>
            <Tooltip title="logout">
              <Link
                href="#"
                color="inherit"
                onClick={() => {
                  dispatch(clearCredentials());
                }}
                sx={{ display: "block", marginTop: "16px" }}
              >
                <LogoutIcon />
              </Link>
            </Tooltip>
          </Box>
        </Grid>
      </Grid>

      <Box sx={{ px: 4, py: 2 }}>
        {pageState === PageStates.Companies ? (
          <TableContainer component={Paper} sx={{ borderRadius: "4px", border: "1px solid #E8E8E8" }}>
            <Table sx={{ minWidth: 650, marginTop: "10px" }} aria-label="simple table">
              <TableHead sx={{ ".MuiTableCell-root": { fontWeight: 800, fontSize: "1rem" }, mt: 0 }}>
                <TableRow>
                  <TableCell>Company</TableCell>
                  <TableCell>Application Status</TableCell>
                  <TableCell>Created Date</TableCell>
                  <TableCell>Processing Status</TableCell>
                  <TableCell>Properties</TableCell>
                  <TableCell>Residents</TableCell>
                  <TableCell>Go Live Date</TableCell>
                  <TableCell>1st Trans</TableCell>
                  <TableCell>
                    <Stack direction="row" justifyContent="center" alignItems="center" spacing={1} textAlign="center">
                      Uuid
                    </Stack>
                  </TableCell>
                  <TableCell>
                    <Stack direction="row" justifyContent="center" alignItems="center" spacing={1} textAlign="center">
                      PM Portal
                    </Stack>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody sx={{ ".MuiTableCell-root": { padding: "8px 16px 12px" } }}>
                {companyDataBook?.[currentPage]?.Rows?.map((entity: AdminCompanyDto, index) => (
                  <TableRow key={entity.Uuid} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                    <TableCell>
                      <div onClick={() => handleViewCompanyDetail(entity)} style={{ textDecoration: 'underline', cursor: 'pointer' }}>{entity.Name}</div>
                    </TableCell>
                    <TableCell>{capitalizeFirstLetter(entity.Status?.replace('APPLICATION_', '').toLocaleLowerCase() ?? '')}</TableCell>
                    <TableCell>{entity.CreatedDate ? format(new Date(entity.CreatedDate), 'yyyy-MM-dd') : ''}</TableCell>
                    <TableCell>
                      <span style={{
                        color: entity.ProcessingStatus === 'Partial' ? '#DBAE39' : entity.ProcessingStatus === 'Not Enabled' ? '#DB3939' : '#14142B',
                      }}>
                        {entity.ProcessingStatus}
                      </span>
                    </TableCell>
                    <TableCell>{entity.Properties}</TableCell>
                    <TableCell>{entity.Residents}</TableCell>
                    <TableCell>{entity.GoLiveDate ? format(new Date(entity.GoLiveDate), 'yyyy-MM-dd') : ''}</TableCell>
                    <TableCell>{entity.FirstTransDate ? format(new Date(entity.FirstTransDate), 'yyyy-MM-dd') : ''}</TableCell>
                    <TableCell>
                      <Grid container display='flex' justifyContent='center' alignItems='stretch' columnGap={1}>
                        <Grid item>
                          <CopyToClipboard text={entity.Uuid}>
                            <Tooltip title={'Copied'} open={openToolTip === index} onClose={() => onToggleClick(null)} onClick={() => onToggleClick(index)} sx={{cursor: "pointer"}}>
                              <ContentCopyIcon fontSize="small" />
                            </Tooltip>
                          </CopyToClipboard>
                        </Grid>
                      </Grid>
                    </TableCell>
                    <TableCell>
                      <Stack direction="row" justifyContent="center" alignItems="center" spacing={1} textAlign="center">
                        {entity.AdminPMProfileUuid && <img style={{ cursor: 'pointer', marginLeft: '5px' }} src={PortalIcon} alt="details-icon" onClick={() => window.open(`/login?logAsEntityUuid=${entity.AdminPMProfileUuid}&logAsUserUuid=${entity.AdminPMUserUuid||''}`)} />}
                      </Stack>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <TablePagination
              component="div"
              rowsPerPageOptions={[20, 30, 40]}
              count={companyData.TotalCount || 0}
              page={currentPage}
              onPageChange={handleChangePage}
              rowsPerPage={rangeSize}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TableContainer>
        ) : pageState === PageStates.CompanyDetail ? (
          <Box>
            {companyDetailError ? (
              <Typography>Unable to fetch company detail</Typography>
            ) : CompanyDetail.Uuid ? (
              <Box>
                {/* Company General Details */}
                <Box sx={{ borderRadius: "4px", border: "1px solid #E8E8E8" }}>
                  <Typography sx={{ px: 1, py: 1.5, background: '#F1F0F5' }} className={classes.sectionLabel}>
                    Company General Details
                  </Typography>
                  <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                      <TableHead sx={{ ".MuiTableCell-root": { fontWeight: 800, fontSize: "1rem" }, mt: 0 }}>
                        <TableRow>
                          <TableCell>Id</TableCell>
                          <TableCell>Uuid</TableCell>
                          <TableCell>Legal Name</TableCell>
                          <TableCell>Application Status</TableCell>
                          {CompanyDetail.AdminPm && (
                            <TableCell>
                              <Stack direction="row" justifyContent="center" alignItems="center" spacing={1} textAlign="center">
                                PM Portal
                              </Stack>
                            </TableCell>
                          )}
                        </TableRow>
                      </TableHead>
                      <TableBody sx={{ ".MuiTableCell-root": { padding: "8px 16px 12px" } }}>
                        <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                          <TableCell>{CompanyDetail.Id}</TableCell>
                          <TableCell>{CompanyDetail.Uuid}</TableCell>
                          <TableCell>{CompanyDetail.LegalName}</TableCell>
                          <TableCell>{capitalizeFirstLetter(CompanyDetail.Status?.replace('APPLICATION_', '').toLocaleLowerCase() ?? '')}</TableCell>
                          {CompanyDetail.AdminPm && (
                            <TableCell>
                              <Stack direction="row" justifyContent="center" alignItems="center" spacing={1} textAlign="center">
                                <Tooltip title={CompanyDetail.AdminPm?.ProfileUuid ?? ''}>
                                  <Link
                                    href="#"
                                    underline="hover"
                                    color="inherit"
                                    onClick={() => window.open(`/login?logAsEntityUuid=${CompanyDetail.AdminPm?.ProfileUuid}&logAsUserUuid=${CompanyDetail.AdminPm?.UserUuid||''}`)}
                                  >
                                    <img style={{ cursor: 'pointer', marginLeft: '5px' }} src={PortalIcon} alt="details-icon" onClick={() => {}} />
                                  </Link>
                                </Tooltip>
                              </Stack>
                            </TableCell>                          
                          )}
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>

                {/* Products Enabled */}
                <Box sx={{ mt: 4, borderRadius: "4px", border: "1px solid #E8E8E8" }}>
                  <Typography sx={{ px: 1, py: 1.5, background: '#F1F0F5' }} className={classes.sectionLabel}>
                    Products Enabled
                  </Typography>
                  <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                      <TableHead sx={{ ".MuiTableCell-root": { fontWeight: 800, fontSize: "1rem" }, mt: 0 }}>
                        <TableRow>
                          <TableCell>Type</TableCell>
                          <TableCell sx={{ textAlign: 'center' }}>Master Flag</TableCell>
                          <TableCell sx={{ textAlign: 'center' }}>Purchased</TableCell>
                          <TableCell sx={{ textAlign: 'center' }}>Enabled</TableCell>
                          <TableCell sx={{ textAlign: 'center' }}>Onboarding Complete</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody sx={{ ".MuiTableCell-root": { padding: "8px 16px 12px" } }}>
                        <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                          <TableCell>Payments</TableCell>
                          <TableCell sx={{ textAlign: 'center' }}>
                            <FormControl sx={{ width: 70 }}>
                              <Select
                                value={paymentsMFlag}
                                onChange={(e: SelectChangeEvent) => {
                                  setPaymentsMFlag(e.target.value);
                                  dispatch({
                                    type: getUpdateCompanyProductConfigs.type,
                                    payload: {
                                      CompanyUuid: CompanyDetail.Uuid,
                                      ProductConfigs: {
                                        PaymentsMasterFlag: e.target.value === 'yes',
                                      },
                                    },
                                  });
                                }}
                                displayEmpty
                                inputProps={{ 'aria-label': 'Without label' }}
                                sx={{ '& .MuiSelect-select': {
                                  paddingTop: '5px !important', 
                                  paddingBottom: '5px !important',
                                  fontSize: '14px !important',
                                }}}
                              >
                                <MenuItem value='yes'>Yes</MenuItem>
                                <MenuItem value='no'>No</MenuItem>
                              </Select>
                            </FormControl>
                          </TableCell>
                          <TableCell sx={{ textAlign: 'center' }}>{CompanyDetail.ProductConfigs?.PaymentsProductPurchased ? 'Yes' : 'No'}</TableCell>
                          <TableCell sx={{ textAlign: 'center' }}>{CompanyDetail.ProductConfigs?.PaymentsProductEnabled ? 'Yes' : 'No'}</TableCell>
                          <TableCell sx={{ textAlign: 'center' }}>
                            {CompanyDetail.ProductConfigs?.PaymentOnboardingCompleteDate ? (
                              <Typography className={classes.labelText}>
                                {CompanyDetail.ProductConfigs?.PaymentOnboardingCompleteDate ? format(new Date(CompanyDetail.ProductConfigs?.PaymentOnboardingCompleteDate), 'yyyy-MM-dd') : ''}
                              </Typography>
                            ) : (
                              <Button variant="contained" onClick={() => {
                                setIsUpdatingPaymentOnboarding(true);
                                dispatch({
                                  type: getUpdateCompanyProductConfigs.type,
                                  payload: {
                                    CompanyUuid: CompanyDetail.Uuid,
                                    ProductConfigs: {
                                      PaymentOnboardingComplete: true,
                                    },
                                  },
                                });
                              }}>
                                {isUpdatingCompanyProductConfigs && isUpdatingPaymentOnboarding ? <CircularProgress size={14} sx={{ color: '#ffffff', mr: 0.5 }} />: ''}
                                Complete
                              </Button>
                            )}
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                          <TableCell>Maintenance</TableCell>
                          <TableCell sx={{ textAlign: 'center' }}>
                            <FormControl sx={{ width: 70 }}>
                              <Select
                                value={maintenanceMFlag}
                                onChange={(e: SelectChangeEvent) => {
                                  setMaintenanceMFlag(e.target.value);
                                  dispatch({
                                    type: getUpdateCompanyProductConfigs.type,
                                    payload: {
                                      CompanyUuid: CompanyDetail.Uuid,
                                      ProductConfigs: {
                                        MaintenanceMasterFlag: e.target.value === 'yes',
                                      },
                                    },
                                  });
                                }}
                                displayEmpty
                                inputProps={{ 'aria-label': 'Without label' }}
                                sx={{ '& .MuiSelect-select': {
                                  paddingTop: '5px !important', 
                                  paddingBottom: '5px !important',
                                  fontSize: '14px !important',
                                }}}
                              >
                                <MenuItem value='yes'>Yes</MenuItem>
                                <MenuItem value='no'>No</MenuItem>
                              </Select>
                            </FormControl>
                          </TableCell>
                          <TableCell sx={{ textAlign: 'center' }}>{CompanyDetail.ProductConfigs?.MaintenanceProductPurchased ? 'Yes' : 'No'}</TableCell>
                          <TableCell sx={{ textAlign: 'center' }}>{CompanyDetail.ProductConfigs?.MaintenanceProductEnabled ? 'Yes' : 'No'}</TableCell>
                          <TableCell sx={{ textAlign: 'center' }}>
                            {CompanyDetail.ProductConfigs?.ApplicationOnboardingCompleteDate ? (
                              <Typography className={classes.labelText}>
                                {CompanyDetail.ProductConfigs?.ApplicationOnboardingCompleteDate ? format(new Date(CompanyDetail.ProductConfigs?.ApplicationOnboardingCompleteDate), 'yyyy-MM-dd') : ''}
                              </Typography>
                            ) : (
                              <Button variant="contained" onClick={() => {
                                setIsUpdatingApplicationOnboarding(true);
                                dispatch({
                                  type: getUpdateCompanyProductConfigs.type,
                                  payload: {
                                    CompanyUuid: CompanyDetail.Uuid,
                                    ProductConfigs: {
                                      ApplicationOnboardingComplete: true,
                                    },
                                  },
                                });
                              }}>
                                {isUpdatingCompanyProductConfigs && isUpdatingApplicationOnboarding ? <CircularProgress size={14} sx={{ color: '#ffffff', mr: 0.5 }} />: ''}
                                Complete
                              </Button>
                            )}
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                          <TableCell>Applications</TableCell>
                          <TableCell sx={{ textAlign: 'center' }}>
                            <FormControl sx={{ width: 70 }}>
                              <Select
                                value={applicationsMFlag}
                                onChange={(e: SelectChangeEvent) => {
                                  setApplicationsMFlag(e.target.value);
                                  dispatch({
                                    type: getUpdateCompanyProductConfigs.type,
                                    payload: {
                                      CompanyUuid: CompanyDetail.Uuid,
                                      ProductConfigs: {
                                        ApplicationsMasterFlag: e.target.value === 'yes',
                                      },
                                    },
                                  });
                                }}
                                displayEmpty
                                inputProps={{ 'aria-label': 'Without label' }}
                                sx={{ '& .MuiSelect-select': {
                                  paddingTop: '5px !important', 
                                  paddingBottom: '5px !important',
                                  fontSize: '14px !important',
                                }}}
                              >
                                <MenuItem value='yes'>Yes</MenuItem>
                                <MenuItem value='no'>No</MenuItem>
                              </Select>
                            </FormControl>
                          </TableCell>
                          <TableCell sx={{ textAlign: 'center' }}>{CompanyDetail.ProductConfigs?.ApplicationsProductPurchased ? 'Yes' : 'No'}</TableCell>
                          <TableCell sx={{ textAlign: 'center' }}>{CompanyDetail.ProductConfigs?.ApplicationsProductEnabled ? 'Yes' : 'No'}</TableCell>
                          <TableCell sx={{ textAlign: 'center' }}>
                            {CompanyDetail.ProductConfigs?.MaintenanceOnboardingCompleteDate ? (
                              <Typography className={classes.labelText}>
                                {CompanyDetail.ProductConfigs?.MaintenanceOnboardingCompleteDate ? format(new Date(CompanyDetail.ProductConfigs?.MaintenanceOnboardingCompleteDate), 'yyyy-MM-dd') : ''}
                              </Typography>
                            ) : (
                              <Button variant="contained" onClick={() => {
                                setIsUpdatingMaintenanceOnboarding(true);
                                dispatch({
                                  type: getUpdateCompanyProductConfigs.type,
                                  payload: {
                                    CompanyUuid: CompanyDetail.Uuid,
                                    ProductConfigs: {
                                      MaintenanceOnboardingComplete: true,
                                    },
                                  },
                                });
                              }}>
                                {isUpdatingCompanyProductConfigs && isUpdatingMaintenanceOnboarding ? <CircularProgress size={14} sx={{ color: '#ffffff', mr: 0.5 }} />: ''}
                                Complete
                              </Button>
                            )}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>

                {/* Merchant Processing */}
                <Box sx={{ mt: 4, borderRadius: "4px", border: "1px solid #E8E8E8" }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', px: 1, py: 1.5, background: '#F1F0F5' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Typography className={classes.sectionLabel}>
                        Merchant Processing
                      </Typography>
                      <Typography sx={{ ml: 2 }} className={classes.labelText}>
                        Payment Processing Application Status: {CompanyDetail.PaymentProcessingStatus}
                      </Typography>
                    </Box>
                    {CompanyDetail.PaymentProcessingStatus === AdminCompanyDetailDtoPaymentProcessingStatusEnum.Submitted && (
                      <Button variant="contained" onClick={onboardMerchant}>
                        {isSubmittingOnboardMerchant ? <CircularProgress size={14} sx={{ color: '#ffffff', mr: 0.5 }} />: ''}
                        Onboard Merchant
                      </Button>
                    )}
                  </Box>

                  <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                      <TableHead sx={{ ".MuiTableCell-root": { fontWeight: 800, fontSize: "1rem" }, mt: 0 }}>
                        <TableRow>
                          <TableCell>Type</TableCell>
                          <TableCell>Processor</TableCell>
                          <TableCell>Merchant</TableCell>
                          <TableCell>Enabled Date</TableCell>
                          <TableCell>Status</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody sx={{ ".MuiTableCell-root": { padding: "8px 16px 12px" } }}>
                        <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                          <TableCell>ACH</TableCell>
                          <TableCell>{achMerchant?.Processor ?? ''}</TableCell>
                          <TableCell>{achMerchant?.ExternalRefId ?? ''}</TableCell>
                          <TableCell>{achMerchant?.EnabledDate ? format(new Date(achMerchant.EnabledDate), 'yyyy-MM-dd') : ''}</TableCell>
                          <TableCell>{achMerchant?.Status ?? ''}</TableCell>
                        </TableRow>
                        <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                          <TableCell>Card</TableCell>
                          <TableCell>{cardMerchant?.Processor ?? ''}</TableCell>
                          <TableCell>{cardMerchant?.ExternalRefId ?? ''}</TableCell>
                          <TableCell>{cardMerchant?.EnabledDate ? format(new Date(cardMerchant.EnabledDate), 'yyyy-MM-dd') : ''}</TableCell>
                          <TableCell>{cardMerchant?.Status ?? ''}</TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>

                {/* Bank Accounts */}
                <Box sx={{ my: 4, borderRadius: "4px", border: "1px solid #E8E8E8" }}>
                  <Typography sx={{ px: 1, py: 1.5, background: '#F1F0F5' }} className={classes.sectionLabel}>
                    Bank Accounts
                  </Typography>
                  <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                      <TableHead sx={{ ".MuiTableCell-root": { fontWeight: 800, fontSize: "1rem" }, mt: 0 }}>
                        <TableRow>
                          <TableCell>Id</TableCell>
                          <TableCell>Bank Name</TableCell>
                          <TableCell>Routing number</TableCell>
                          <TableCell>Account number</TableCell>
                          <TableCell>
                            <Stack direction="row" justifyContent="center" alignItems="center" spacing={1} textAlign="center">
                              Details
                            </Stack>
                          </TableCell>
                          <TableCell>
                            <Stack direction="row" justifyContent="center" alignItems="center" spacing={1} textAlign="center">
                              Download
                            </Stack>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody sx={{ ".MuiTableCell-root": { padding: "8px 16px 12px" } }}>
                        {CompanyDetail.BankAccounts?.map((ba, index) => 
                          <TableRow key={index} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                            <TableCell>{ba.Id}</TableCell>
                            <TableCell>{ba.BankName}</TableCell>
                            <TableCell>{ba.RoutingNumber}</TableCell>
                            <TableCell>{ba.AccountNumber}</TableCell>
                            <TableCell>
                              <Stack direction="row" justifyContent="center" alignItems="center" spacing={1} textAlign="center">
                                <img style={{ cursor: 'pointer', marginLeft: '5px' }} src={CompanyDetailsIcon} alt="details-icon" onClick={() => handleViewBankAccount(ba)} />
                              </Stack>
                            </TableCell>
                            <TableCell>
                              <Stack direction="row" justifyContent="center" alignItems="center" spacing={1} textAlign="center">
                                {isExportingBankFiles && selectedBank?.Uuid === ba.Uuid ? (
                                  <CircularProgress size={16} sx={{ color: '#000000' }} />
                                ) : (
                                  <img style={{ cursor: 'pointer', marginLeft: '5px' }} src={ExportIcon} alt="details-icon" onClick={() => handleExportBankAccountFiles(CompanyDetail.Uuid, ba)} />
                                )}
                              </Stack>
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Box>
            ) : (
              <></>
            )}
          </Box>
        ) : pageState === PageStates.BankDetail ? (
          <Box>
            {/* Processor External Entity Records */}
            <Box sx={{ borderRadius: "4px", border: "1px solid #E8E8E8" }}>
              <Typography sx={{ px: 1, py: 1.5, background: '#F1F0F5' }} className={classes.sectionLabel}>
                Processor External Entity Records
              </Typography>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead sx={{ ".MuiTableCell-root": { fontWeight: 800, fontSize: "1rem" }, mt: 0 }}>
                    <TableRow>
                      <TableCell>Type</TableCell>
                      <TableCell>Processor</TableCell>
                      <TableCell>Credit</TableCell>
                      <TableCell>Enabled Date</TableCell>
                      <TableCell>Status</TableCell>
                      <TableCell>Debit</TableCell>
                      <TableCell>Enabled Date</TableCell>
                      <TableCell>Status</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody sx={{ ".MuiTableCell-root": { padding: "8px 16px 12px" } }}>
                    <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                      <TableCell>ACH</TableCell>
                      <TableCell>{achCredit?.Processor ?? ''}</TableCell>
                      <TableCell>{achCredit?.ExternalRefId ?? ''}</TableCell>
                      <TableCell>{achCredit?.EnabledDate ? format(new Date(achCredit.EnabledDate), 'yyyy-MM-dd') : ''}</TableCell>
                      <TableCell>{achCredit?.Status ?? ''}</TableCell>
                      <TableCell>{achDebit?.ExternalRefId ?? ''}</TableCell>
                      <TableCell>{achDebit?.EnabledDate ? format(new Date(achDebit.EnabledDate), 'yyyy-MM-dd') : ''}</TableCell>
                      <TableCell>{achDebit?.Status ?? ''}</TableCell>
                    </TableRow>
                    <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                      <TableCell>Card</TableCell>
                      <TableCell>{cardCredit?.Processor ?? ''}</TableCell>
                      <TableCell>{cardCredit?.ExternalRefId ?? ''}</TableCell>
                      <TableCell>{cardCredit?.EnabledDate ? format(new Date(cardCredit.EnabledDate), 'yyyy-MM-dd') : ''}</TableCell>
                      <TableCell>{cardCredit?.Status ?? ''}</TableCell>
                      <TableCell>{cardDebit?.ExternalRefId ?? ''}</TableCell>
                      <TableCell>{cardDebit?.EnabledDate ? format(new Date(cardDebit.EnabledDate), 'yyyy-MM-dd') : ''}</TableCell>
                      <TableCell>{cardDebit?.Status ?? ''}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Box>
        ) : (
          <></>
        )}
      </Box>
    </Stack>
  );
}
